var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7421 9.63861C41.7421 18.8486 22.4721 41.7686 8.74213 49.9486M49.9621 49.4286C40.7521 42.4286 18.2921 23.5086 10.1121 9.79861M57.7721 30.0386C51.8917 28.9869 46.3711 26.4704 41.7202 22.7214C37.0693 18.9723 33.4382 14.1118 31.1621 8.58861C30.1752 6.16436 29.4868 3.62908 29.1121 1.03861M1.20213 33.6386C10.3621 36.5886 19.5121 44.8986 24.4021 54.5386C24.8945 55.5134 25.3318 56.5149 25.7121 57.5386M21.2221 2.26861C35.9521 -2.61139 51.2221 7.16861 56.3021 21.6586C57.5171 25.2306 57.9723 29.017 57.6385 32.7752C57.3046 36.5333 56.1892 40.1802 54.3636 43.4821C52.538 46.784 50.0426 49.6679 47.0373 51.9491C44.0321 54.2302 40.5833 55.8582 36.9121 56.7286C21.0421 60.3486 5.41213 53.0386 1.83213 37.3386C-1.74787 21.6386 6.50213 7.13861 21.2221 2.26861ZM29.8421 10.8186C42.1621 3.56861 51.3321 7.31861 51.7121 17.0986C52.0921 26.8786 41.4621 41.8686 28.5721 48.4486C15.6821 55.0286 5.57213 53.2686 6.69213 42.1686C7.81213 31.0686 17.5121 18.0386 29.8421 10.8186Z",
    stroke: "#FACE7A",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape2.9218c77455c5fbed064f4f726c8babdc.svg";
export { ForwardRef as ReactComponent };